import axios from 'axios';
import { API_KEY, API_REGISTER, RECAPTCHA_TOKEN_FIELD } from '../../enums';

const processRegisterForm = (registerForm) => {
  return {
    ...registerForm,
    profiles: [{
      name: `${registerForm.forename} ${registerForm.surname}`,
      forename: registerForm.forename,
      surname: registerForm.surname,
      nationality_id: registerForm.nationality_id,
      country_id: registerForm.country_id,
      title: registerForm.title
    }],
    type: 'default',
    status: 'active',
    guest: 0,
    name: registerForm.email
  }
}

export const register = async (registerForm, recaptchaResult) => {

  let processedForm = processRegisterForm(registerForm);

  let params = {
    ...processedForm,
    api: API_KEY,
    [RECAPTCHA_TOKEN_FIELD]: recaptchaResult
  }

  return await axios({
    method: 'POST',
    url: API_REGISTER,
    data: params
  });
}